export default __webpack_public_path__ + "static/media/star-of-life-solid.af87991c.svg";